<section class="wraper-sub">
  <div class="unpaid-order-m">
    <div class="top-page-m">
      <div class="top-section">
        <h1 class="page-name">Signups</h1>
      </div>
      <div class="filter-sub-m">
        <div class="filter-m">
          <div class="filter">
            <div class="fields-m largeField">
              <input type="text" name="search" (change)="rerender()" [(ngModel)]="searchParams.emailId" placeholder="Search by Order ID, Email or Phone">
              <i class="fa fa-search" aria-hidden="true" (change)="rerender()"></i>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m date-filter">
              <input (onHidden)="splitFromTo()" [(ngModel)]="fullRangeDate" type="text" placeholder="Date Range" bsDaterangepicker [bsConfig]="{ isAnimated: true, showWeekNumbers: false}">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.2422 1.17188H12.5391V0H11.3672V1.17188H3.63281V0H2.46094V1.17188H1.75781C0.788555 1.17188 0 1.96043 0 2.92969V13.2422C0 14.2114 0.788555 15 1.75781 15H13.2422C14.2114 15 15 14.2114 15 13.2422V2.92969C15 1.96043 14.2114 1.17188 13.2422 1.17188ZM13.8281 13.2422C13.8281 13.5653 13.5653 13.8281 13.2422 13.8281H1.75781C1.43473 13.8281 1.17188 13.5653 1.17188 13.2422V5.50781H13.8281V13.2422ZM13.8281 4.33594H1.17188V2.92969C1.17188 2.6066 1.43473 2.34375 1.75781 2.34375H2.46094V3.51562H3.63281V2.34375H11.3672V3.51562H12.5391V2.34375H13.2422C13.5653 2.34375 13.8281 2.6066 13.8281 2.92969V4.33594Z"
                    fill="#1C212D" />
                <path d="M3.39844 6.73828H2.22656V7.91016H3.39844V6.73828Z" fill="#1C212D" />
                <path d="M5.74219 6.73828H4.57031V7.91016H5.74219V6.73828Z" fill="#1C212D" />
                <path d="M8.08643 6.73828H6.91455V7.91016H8.08643V6.73828Z" fill="#1C212D" />
                <path d="M10.4297 6.73828H9.25781V7.91016H10.4297V6.73828Z" fill="#1C212D" />
                <path d="M12.7734 6.73828H11.6016V7.91016H12.7734V6.73828Z" fill="#1C212D" />
                <path d="M3.39844 9.08203H2.22656V10.2539H3.39844V9.08203Z" fill="#1C212D" />
                <path d="M5.74219 9.08203H4.57031V10.2539H5.74219V9.08203Z" fill="#1C212D" />
                <path d="M8.08643 9.08203H6.91455V10.2539H8.08643V9.08203Z" fill="#1C212D" />
                <path d="M10.4297 9.08203H9.25781V10.2539H10.4297V9.08203Z" fill="#1C212D" />
                <path d="M3.39844 11.4258H2.22656V12.5977H3.39844V11.4258Z" fill="#1C212D" />
                <path d="M5.74219 11.4258H4.57031V12.5977H5.74219V11.4258Z" fill="#1C212D" />
                <path d="M8.08643 11.4258H6.91455V12.5977H8.08643V11.4258Z" fill="#1C212D" />
                <path d="M10.4297 11.4258H9.25781V12.5977H10.4297V11.4258Z" fill="#1C212D" />
                <path d="M12.7734 9.08203H11.6016V10.2539H12.7734V9.08203Z" fill="#1C212D" />
              </svg>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m select-m" *ngIf="siteList && siteList.length > 0">
              <ng-select 
                [items]="siteList"
                bindLabel="abbr"
                bindValue="site_link"
                placeholder="Site"
                appendTo="body"
                [(ngModel)]="searchParams.site_link"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="true"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.abbr }}
                </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z"
                    fill="#1C212D" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="data-tables-m">
      <div class="table-responsive">
        <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
            <tr>
              <th>Customer ID</th>
              <th>Timestamp</th>
              <!-- <th>Name</th>
              <th>Email</th>
              <th>Phone</th> -->
              
              <th>Site Link</th>
               <th>Info</th>
              <th>Email 1</th>
              <th>Email 2</th>
              <th>Email 3</th>
              <th>Email 4</th>
             
              <!-- <th>Comments</th> -->
            </tr>
          </thead>

          <ng-container *ngIf="leads.data && leads.data.length > 0">
            <tbody>
              <tr *ngFor="let lead of leads.data; let indx = index">
                <td>{{ lead.id }}</td>

                <td>
                  <p *ngIf="lead.join_date">{{ lead.join_date | date }}</p>
                  <p *ngIf="lead.join_date">{{ lead.join_date | date:'shortTime' }}</p>
                </td>

                

                <td>
                  <p>{{ lead.site_link }}</p>
                </td>
                 <td>
              <p>{{ lead.first_name }}{{ lead.last_name ? ' ' + lead.last_name : '' }}</p>
                  <p>{{ lead.email }}</p>
                  <p>{{ lead.phone }}</p>
                </td>
<td>
  <!-- For status = 0 -->
  <ng-container *ngIf="lead.email1_status == 0 && lead.email1_datetime !== 'Stopped'">
    <p>To be sent in</p>
    <p>{{ countdowns[lead.id + '_1'] }}</p>
  </ng-container>

  <!-- For status = 1 -->
  <ng-container *ngIf="lead.email1_status == 1">
    <div class="pos-rel">
      <p class="sent-click"  (click)="clickedIndex = indx">Sent</p>
    </div>
    <!-- Fullscreen Modal Popup -->
  <div class="fullscreen-backdrop" *ngIf="clickedIndex === indx" (click)="clickedIndex = null">
    <div class="fullscreen-popup" (click)="$event.stopPropagation()">
      <button class="close-btn" (click)="clickedIndex = null">&times;</button>
      <app-signup-email-1-preview 
        [username]="lead.first_name" 
        [sitename]="lead.site_link">
      </app-signup-email-1-preview>
    </div>
  </div>
    <p>{{ lead.email1_datetime }}</p>
  </ng-container>

  <!-- For datetime = Stopped -->
  <p *ngIf="lead.email1_datetime === 'Stopped'">{{ lead.email1_datetime }}</p>
</td>
   <td>
  <!-- For status = 0 -->
  <ng-container *ngIf="lead.email2_status == 0 && lead.email2_datetime !== 'Stopped'">
    <p>To be sent in</p>
    <p>{{ countdowns[lead.id + '_2'] }}</p>
  </ng-container>

  <!-- For status = 1 -->
  <ng-container *ngIf="lead.email2_status == 1">
    <div class="pos-rel">
      <p class="sent-click" (click)="clickedIndex = indx + '-2'">Sent</p>
    </div>

    <!-- Fullscreen Modal Popup -->
    <div class="fullscreen-backdrop" *ngIf="clickedIndex === (indx + '-2')" (click)="clickedIndex = null">
      <div class="fullscreen-popup" (click)="$event.stopPropagation()">
        <button class="close-btn" (click)="clickedIndex = null">&times;</button>
        <app-signup-email-2-preview 
          [username]="lead.first_name" 
          [sitename]="lead.site_link"
          [trialUser]="lead.trial_user"
          >
        </app-signup-email-2-preview>
      </div>
    </div>

    <p>{{ lead.email2_datetime }}</p>
  </ng-container>

  <!-- For datetime = Stopped -->
  <p *ngIf="lead.email2_datetime === 'Stopped'">{{ lead.email2_datetime }}</p>
</td>
 <td>
  <!-- For status = 0 -->
  <ng-container *ngIf="lead.email3_status == 0 && lead.email3_datetime !== 'Stopped'">
    <p>To be sent in</p>
    <p>{{ countdowns[lead.id + '_3'] }}</p>
  </ng-container>

  <!-- For status = 1 -->
  <ng-container *ngIf="lead.email3_status == 1">
    <div class="pos-rel">
      <p class="sent-click" (click)="clickedIndex = indx + '-3'">Sent</p>
    </div>

    <!-- Fullscreen Modal Popup -->
    <div class="fullscreen-backdrop" *ngIf="clickedIndex === (indx + '-3')" (click)="clickedIndex = null">
      <div class="fullscreen-popup" (click)="$event.stopPropagation()">
        <button class="close-btn" (click)="clickedIndex = null">&times;</button>
        <app-signup-email-3-preview 
          [username]="lead.first_name" 
          [sitename]="lead.site_link"
             [trialUser]="lead.trial_user"
          >
        </app-signup-email-3-preview>
      </div>
    </div>

    <p>{{ lead.email3_datetime }}</p>
  </ng-container>

  <!-- For datetime = Stopped -->
  <p *ngIf="lead.email3_datetime === 'Stopped'">{{ lead.email3_datetime }}</p>
</td>
 <td>
  <!-- For status = 0 -->
  <ng-container *ngIf="lead.email4_status == 0 && lead.email4_datetime !== 'Stopped'">
    <p>To be sent in</p>
    <p>{{ countdowns[lead.id + '_4'] }}</p>
  </ng-container>

  <!-- For status = 1 -->
  <ng-container *ngIf="lead.email4_status == 1">
    <div class="pos-rel">
      <p class="sent-click" (click)="clickedIndex = indx + '-4'">Sent</p>
    </div>

    <!-- Fullscreen Modal Popup -->
    <div class="fullscreen-backdrop" *ngIf="clickedIndex === (indx + '-4')" (click)="clickedIndex = null">
      <div class="fullscreen-popup" (click)="$event.stopPropagation()">
        <button class="close-btn" (click)="clickedIndex = null">&times;</button>
        <app-signup-email-4-preview 
          [username]="lead.first_name" 
          [sitename]="lead.site_link"
           [trialUser]="lead.trial_user"
          >
        </app-signup-email-4-preview>
      </div>
    </div>

    <p>{{ lead.email4_datetime }}</p>
  </ng-container>

  <!-- For datetime = Stopped -->
  <p *ngIf="lead.email4_datetime === 'Stopped'">{{ lead.email4_datetime }}</p>
</td>

               
                <!-- <td>
                  
                </td>

                <td>
                  
                </td> -->
                <!-- <td>
                  <div class="pos-rel">
                    <a href="javascript:;" (click)="showAdminComments(lead, indx, 'Unpaid-Comments')" *ngIf="!lead.loadingComs">
                      <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M19.873 0H5.12695C2.29988 0 0 2.23443 0 4.98105V12.6743C0 14.8659 1.48106 16.7747 3.6272 17.3857L6.10332 19.7915C6.24084 19.925 6.427 20 6.62136 20C6.81553 20 7.00188 19.925 7.13921 19.7915L9.41067 17.5845H19.873C22.7001 17.5845 25 15.3501 25 12.6035V4.98105C25 2.23443 22.7001 0 19.873 0ZM23.5352 12.6035C23.5352 14.5653 21.8924 16.1614 19.873 16.1614H9.1074C8.91323 16.1614 8.72688 16.2364 8.58955 16.3698L6.62136 18.282L4.52518 16.2455C4.43115 16.1541 4.31328 16.0893 4.18415 16.0581C2.58312 15.671 1.46484 14.2796 1.46484 12.6743V4.98105C1.46484 3.01921 3.10764 1.42316 5.12695 1.42316H19.873C21.8924 1.42316 23.5352 3.01921 23.5352 4.98105V12.6035Z"
                            fill="#00A5DC" />
                        <path
                            d="M17.1506 6.82312H7.84961C7.44506 6.82312 7.11719 7.14185 7.11719 7.5347C7.11719 7.92774 7.44506 8.24628 7.84961 8.24628H17.1506C17.5552 8.24628 17.883 7.92774 17.883 7.5347C17.883 7.14185 17.5552 6.82312 17.1506 6.82312Z"
                            fill="#00A5DC" />
                        <path
                            d="M17.1506 9.33826H7.84961C7.44506 9.33826 7.11719 9.6568 7.11719 10.0498C7.11719 10.4429 7.44506 10.7614 7.84961 10.7614H17.1506C17.5552 10.7614 17.883 10.4429 17.883 10.0498C17.883 9.6568 17.5552 9.33826 17.1506 9.33826Z"
                            fill="#00A5DC" />
                      </svg>
                    </a>

                    <!-- Action Loader --
                    <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="lead.loadingComs"></i>

                    <!-- Action Popup --
                    <div class="comment-modal-m">
                      <div class="modal fade" [id]="'comment_modal'+indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel1" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel1" [ngClass]="{'w-100': qaComments.length == 0}" *ngIf="agentComments.length > 0">Agent Comments</h5>
                            <h5 class="modal-title qa-comment" id="exampleModalLabel1" [ngClass]="{'w-100': agentComments.length == 0}" *ngIf="qaComments.length > 0">Q/A Comments</h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="comments-sub" [ngClass]="{'w-100': qaComments.length == 0}" *ngIf="agentComments.length > 0">
                                <ng-container *ngFor="let comment of agentComments">
                                  <div class="comment-box">
                                    <label *ngIf="agents">{{ agentSearch(comment.user_id, agents) }}</label>
                                    <p>{{ comment.notes }}</p>
                                    <span class="date-comment">{{ comment.date | customDatePipe: 'dateTime' }}</span>
                                  </div>
                                </ng-container>
                              </div>

                              <div class="comments-sub qa-box" [ngClass]="{'w-100': agentComments.length == 0}" *ngIf="qaComments.length > 0">
                                <ng-container *ngFor="let comment of qaComments">
                                  <div class="comment-box">
                                    <label *ngIf="agents">{{ agentSearch(comment.user_id, qa) }}</label>
                                    <p>{{ comment.notes }}</p>
                                    <span class="date-comment">{{ comment.date | customDatePipe: 'dateTime' }}</span>
                                  </div>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td> -->
              </tr>
           
            </tbody>
          </ng-container>
        </table>
      </div>
    </div>
  </div>
</section>

<!-- floating alert starts -->
<ng-container *ngIf="leads.alertMessage && leads.data && leads.data.length > 0">
    <div class="floatingAlert" *ngIf="floatingAlert">
        <button type="button" class="close" (click)="closeFloatingAlert();">
          <i class="fa fa-times"></i>
        </button>
        <p>{{ leads.alertMessage }}</p>
    </div>
</ng-container>
<!-- floating alert ends -->
